(()=>{
  dayjs.locale('ja');
  const week = ['日', '月', '火', '水', '木', '金', '土'];

  const checkHoliday = (day) => {
    let holidayText = '';

    // 配送休み
    const deliveryholidays = deliver_holidays;

    deliveryholidays.forEach((holiday)=>{
      if( dayjs(day).isSame(dayjs(holiday))){
        holidayText +=  ' deliveryholiday';
      }
      // 曜日が一致する場合
      if( dayjs(day).day() === week.indexOf(holiday) ){
        holidayText +=  ' deliveryholiday';
      }
    });

    // 店舗休み
    const storeholidays = store_holidays;
    storeholidays.forEach((holiday)=>{

      if( dayjs(day).isSame(dayjs(holiday))){
        // console.log('isSame')
        holidayText +=  ' storeholiday';
      }
      // 曜日が一致する場合
      if( dayjs(day).day() === week.indexOf(holiday) ){
        holidayText +=  ' storeholiday';
      }
    });

    return holidayText;
  };

  const initCalender = (ele, date) => {
    //  set title
    const title = ele.querySelector('.footerCalender__monthtitle');
    title.textContent = dayjs(date).format('YYYY年MM月');

    // 最初の日
    const firstDay = dayjs(date).date(1);
    const firstDayWeek = firstDay.day();
    // console.log({firstDayWeek})

    let calenderHTML = '';
    let dayCount = 0;

    for(let i = 0; i < 6; i++){
      calenderHTML += '<tr>';
      for(let j = 0; j < 7; j++){
        if( i === 0 && j < firstDayWeek ){
          calenderHTML += '<td></td>';
        }else if ( dayCount > firstDay.daysInMonth() - 1){
          // 翌月は入れない
        }else{
          const day = firstDay.add((i*7)+j - firstDayWeek, 'day');
          const holidaysclass = checkHoliday(day.format('YYYY/MM/DD'));
          // console.log({holidaysclass})
          calenderHTML += '<td class="'+ holidaysclass +'"><span class="footerCalender__day">' + day.date() + '</span></td>';
          dayCount++;
        }
      }
      calenderHTML += '</tr>';
    }

    ele.querySelector('tbody').innerHTML = calenderHTML;

  };

  document.addEventListener('DOMContentLoaded', ()=>{

    const today = dayjs();

    const thismonth = today.format('YYYY/MM');
    const nextmonth = today.add(1, 'month').format('YYYY/MM');

    const calender_thismonth = document.querySelector('.js-calender.calender1');
    const calender_next = document.querySelector('.js-calender.calender2');

    initCalender(calender_thismonth, thismonth);
    initCalender(calender_next, nextmonth);

  });

})();